import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { UserService } from 'services/user.service';
import { ApplicationService } from 'services/application.service';
import { AlertService } from 'services/alert.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-wifidetails',
  templateUrl: './wifidetails.component.html',
  styleUrls: ['./wifidetails.component.scss']
})
export class WifidetailsComponent implements OnInit {
  form: FormGroup;
  srcApplicationList : any[];
  applicationList : any[];
  dropdownSettings = {};
  wifiCredential = {};
  showCredential = false;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private applicationService:ApplicationService,
     private alertService: AlertService) {
      this.initializeValidators();
     this.dropdownSettings = {
       singleSelection: false,
       idField: 'key',
       textField: 'value',
       selectAllText: 'Select All',
       unSelectAllText: 'Un Select All',
       itemsShowLimit: 4,
       allowSearchFilter: true
   };
   }

  ngOnInit() {
    this.getApplicationList(false);
  }

  getApplicationList(refresh) {
    this.userService.getApplicationList(refresh).subscribe(result => {
      this.srcApplicationList = [];
      this.applicationList = [];
      this.srcApplicationList = result;
      var keyValue = 0;

      this.srcApplicationList.forEach(applicationItem => {
        if(applicationItem.vumatelNetworkIdentifier){
          this.applicationList.push({key : keyValue, value: applicationItem.referenceNumber});
          keyValue = keyValue + 1;
        }
      });
    });
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      
      application: [''],
      newpassword: ['']
       });
  }

  onSubmit()
  {
    if(this.form.value.application.value){
      this.applicationService.getWifiCredentialWithReference(this.form.value.application.value).subscribe(response => {
        this.wifiCredential = response;
  
        if(response && response.result && response.result.wifi_username && response.result.wifi_password){
          this.showCredential = true;
          
        }
        else
          {
            this.showCredential = false;
            swal.fire({ 
              title: "No Record Found!",                            
              icon: 'error',           
              showCancelButton: false,
              confirmButtonColor: '#d33',           
              confirmButtonText: 'Ok',         
            }).then((res) => {
              if (res.value) {                    
                 }
            });
            //this.alertService.warning('No Record Found!');
          }
      });
    }
    else
          {
            this.alertService.warning('Please Select Application');
          }
  }
}
